var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSearchIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3404 13.1223C15.4013 11.7961 16.0356 10.1138 16.0356 8.28343C16.0356 4.00202 12.5648 0.53125 8.28343 0.53125C4.00202 0.53125 0.53125 4.00202 0.53125 8.28343C0.53125 12.5648 4.00202 16.0356 8.28343 16.0356C10.1138 16.0356 11.7961 15.4013 13.1223 14.3404L18.002 19.2201C18.3383 19.5565 18.8838 19.5565 19.2201 19.2201C19.5565 18.8838 19.5565 18.3383 19.2201 18.002L14.3404 13.1223ZM8.28343 14.3215C4.94867 14.3215 2.24531 11.6182 2.24531 8.28343C2.24531 4.94867 4.94867 2.24531 8.28343 2.24531C11.6182 2.24531 14.3215 4.94867 14.3215 8.28343C14.3215 11.6182 11.6182 14.3215 8.28343 14.3215Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Search_Icon.a8eaa5f0.svg";
export { ForwardRef as ReactComponent };